<ng-container *ngIf="edit; else display">
    <div class="bg-layer" #backgroundWrapper>
        <kw-wrapper class="content-layer">
            <div class="layout-layer" [ngClass]="layoutClass">
                <kw-grid-cell-wrapper  class="grid-cell-container" [attr.cell-id]="cell.cellId" *ngFor="let cell of cells; let i = index">
                    <ng-container *ngIf="cell.status === 'Initial Draft';else inProgress">
                        <kw-fill-layer-renderer [fillClass]="cell?.fillClass" [fillColor]="cell?.fillColor"></kw-fill-layer-renderer>
                        <kw-content-layer-renderer [cell]="cell" [ngClass]="layoutClass"></kw-content-layer-renderer>
                    </ng-container>
                    <ng-template #inProgress>
                        <kw-edit-placeholder-renderer [gridCell]="cell" (createGridCellContent)="createContent($event)"></kw-edit-placeholder-renderer>
                    </ng-template>
                </kw-grid-cell-wrapper>
            </div>
        </kw-wrapper>
    </div>
</ng-container>
<ng-template #display>
    <div class="bg-layer" #backgroundWrapper>
        <kw-wrapper class="content-layer">
            <div class="layout-layer" [ngClass]="layoutClass">
                <kw-grid-cell-wrapper  class="grid-cell-container" [attr.cell-id]="cell.cellId" *ngFor="let cell of cells; let i = index">
                    <kw-fill-layer-renderer [fillClass]="cell?.fillClass" [fillColor]="cell?.fillColor"></kw-fill-layer-renderer>
                    <kw-content-layer-renderer [cell]="cell" [ngClass]="layoutClass"></kw-content-layer-renderer>
                </kw-grid-cell-wrapper>
            </div>
        </kw-wrapper>
    </div>
</ng-template>



